export enum View {
	GRID = 'grid',
	LIST = 'list',
}
